import { mixin as clickaway } from 'vue-clickaway';

import template from './filter.vhtml';

export default {
	mixins: [clickaway],
	template: template,
	props: {
		label: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			default: null,
		},
		popupDirection: {
			type: String,
			default: '',
		},
		language: {
			type: String,
			default: 'da',
		},
		isActive: {
			type: Boolean,
			default: false,
		}
	},
	data: () => ({
		isOpen: false,
	}),
	computed: {
		popupDirectionClass() {
			return 'o-select-box__popup--' + this.popupDirection;
		},
		popupInnerDirectionClass() {
			return 'o-select-box__popup-inner--' + this.popupDirection;
		},
	},
	watch: {
	},
	methods: {
		toogleSelected( item ) {
			item.selected = !item.selected;
		},
		resetSelected() {
			this.closeBox;
			this.options.forEach( option => {
				if ( option.selected ) {
					option.selected = false;
				}
			});
		},
		toggleBox() {
			this.isOpen = !this.isOpen;
		},
		closeBox() {
			this.isOpen = false;
		},
	},
};


// WEBPACK FOOTER //
// ./assets/_js/components/filter/filter.js